module.exports = __webpack_public_path__ + "static/media/demo.6d37e00.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo.mp4
// module id = mnUw
// module chunks = 1